import { Component, computed, input, output, TemplateRef } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-support-card",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./support-card.component.html",
  styleUrls: ["./support-card.component.scss"]
})
export class SupportCardComponent {
  icon = input.required<string>();
  iconAlt = input<string>("");
  cardTitle = input.required<string>();
  description = input.required<string>();
  buttonLabel = input.required<string>();
  loadingLabel = input<string>();
  isLoading = input<boolean>(false);
  // Briefly styles the button as a green success state (e.g. after an async action completes).
  success = input<boolean>(false);
  successLabel = input<string>();
  isOffline = input<boolean>(false);
  disabled = input<boolean>(false);
  dimmed = input<boolean>(false);
  testId = input<string>("");
  ariaLabel = input<string>("");
  /** Optional slot for additional dynamic UI (e.g. a progress bar) rendered below the button. */
  customTemplate = input<TemplateRef<unknown>>();

  action = output<Event>();

  displayLabel = computed(() => {
    const successLabel = this.successLabel();
    if (this.success() && successLabel) {
      return successLabel;
    }
    const loadingLabel = this.loadingLabel();
    return this.isLoading() && loadingLabel ? loadingLabel : this.buttonLabel();
  });

  onButtonClick(event: Event): void {
    this.action.emit(event);
  }
}
